import { cn } from '@doccareplus/shared/lib/utils';

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Accessible name. Required since the switch has no visible text of its own. */
  label: string;
  disabled?: boolean;
  className?: string;
}

/**
 * Switch — pill-shaped animated toggle (the app's on/off control for settings
 * rows), matching the switch already hand-rolled in MobileMorePage's dark-mode
 * row and the design mockup's reminder/preference toggles. Not a native
 * checkbox — a button with `role="switch"`, same as that existing usage.
 *
 * NO business logic — pure presentational; the parent owns the checked state.
 */
export function Switch({ checked, onChange, label, disabled, className }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative inline-flex h-[24px] w-[42px] shrink-0 items-center rounded-full border border-transparent transition-colors disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-[var(--primary)]' : 'bg-[var(--surface-3)]',
        className
      )}
    >
      <span
        className={cn(
          'inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow-[var(--shadow-1)] transition-transform',
          checked ? 'translate-x-[21px]' : 'translate-x-[3px]'
        )}
      />
    </button>
  );
}
